<template>
  <action-dialog
    ref="timeoutActionDialog"
    :title="$t('kiosk.inactivityPrompt')"
    :ok-label="$t('assertion.yes')"
    :cancel-label="$t('checkout.actions.startOver') + ' (' + counter + ')'"
    persistent
    @ok="timeout(false)"
    @cancel="() => timeout(true)"
  />
</template>
<script>

import ActionDialog from 'src/modules/consumer/components/ActionDialog'

export default {
  name: 'TimeoutDialog',
  components: {
    ActionDialog
  },
  props: {
    delay: {
      type: Number,
      required: false,
      default: 10
    }
  },
  emits: ['timeout', 'continue'],
  data () {
    return {
      counter: this.delay,
      shown: false,
      timeoutId: null
    }
  },
  configuration: ['currentSite'],
  beforeUnmount () {
    if (this.timeoutId) {
      clearInterval(this.timeoutId)
    }
  },
  methods: {
    show () {
      if (this.timeoutId) {
        clearInterval(this.timeoutId)
      }
      this.counter = this.delay
      this.$refs.timeoutActionDialog.show()
      this.timeoutId = setInterval(() => {
        --this.counter
        if (this.counter <= 0) {
          this.timeout(true)
        }
      }, 1000)

      if (this.$isFeatureEnabled(this.$featureFlags.extra_kiosk_logs)) {
        this.$rollbar.info('Kiosk timeout dialog shown')
      }
    },
    timeout (timeout) {
      clearInterval(this.timeoutId)
      if (timeout) {
        this.$emit('timeout')
      } else {
        this.$emit('continue')
      }

      if (this.$isFeatureEnabled(this.$featureFlags.extra_kiosk_logs)) {
        this.$rollbar.info(timeout ? 'Kiosk timeout' : 'Kiosk timer reset')
      }

      this.$refs.timeoutActionDialog.hide()
    }
  }
}
</script>
